import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BugsnagService } from '@mode/shared/util-error-handling';
import { SpacesClientService } from '@mode/shared/data-access-webapp';
import { SpaceDomain } from '@mode/shared/contract-common';
import { Action, Store } from '@ngrx/store';
import { moveToCollectionSuccess, moveToCollectionFailed } from './collection-move-to.actions';

@Injectable({
  providedIn: 'root',
})
export class CollectionMoveToFacade {
  static Actions = { moveToCollectionSuccess, moveToCollectionFailed };
  protected moveableCollectionsStream = new BehaviorSubject<SpaceDomain.Space[]>([]);
  public moveableCollections$: Observable<SpaceDomain.Space[]>;

  constructor(
    private bugsnagService: BugsnagService,
    private spacesClientService: SpacesClientService,
    private readonly store: Store
  ) {
    this.moveableCollections$ = this.moveableCollectionsStream.asObservable();
  }

  getMoveToCollections(workspaceName: string) {
    this.spacesClientService.getMoveableCollections('mode').subscribe((moveableCollections) => {
      this.moveableCollectionsStream.next(moveableCollections);
    });
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
